import { styled } from "@mui/material";
import { highlighterName } from "../classes.js";
const Highlight = styled("mark", {
  name: highlighterName,
  slot: "highlight",
  overridesResolver: (_props, styles) => [styles.highlight]
})(() => ({
  background: "#FFD54F"
}));
export {
  Highlight
};
//# sourceMappingURL=Highlight.js.map
